import {
  Building2, UsersRound, BookOpen, PlayCircle, FileCheck, Award, BarChart3, Sparkles,
  CreditCard, Bell, Globe, Smartphone, ShieldCheck,
} from "lucide-react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { ADMIN } from "@/constants/adminTestIds";

const MODULES = [
  { name: "Hospital / Institute Management", phase: 3, icon: Building2, desc: "Onboard hospitals, colleges and diagnostic centres as isolated tenants." },
  { name: "Employee & Staff Management", phase: 4, icon: UsersRound, desc: "Bulk-import staff, departments, and course mapping per team." },
  { name: "Course Management", phase: 5, icon: BookOpen, desc: "Course library, categories, mapping and assignment." },
  { name: "Learning Module", phase: 6, icon: PlayCircle, desc: "Videos, PDFs, PPTs, notes, live classes, and progress tracking." },
  { name: "Examination Engine", phase: 7, icon: FileCheck, desc: "Master question bank, random papers, reattempt logic, and proctoring." },
  { name: "Certificate Management", phase: 8, icon: Award, desc: "QR-verified certificates, expiry alerts, and renewal management." },
  { name: "Reports & Compliance", phase: 9, icon: BarChart3, desc: "Audit-grade reporting, training matrix and NABH/JCI compliance." },
  { name: "AI Study Assistant", phase: 10, icon: Sparkles, desc: "AI quiz generation, notes summarization, and personalised learning." },
  { name: "Payments & Subscriptions", phase: 11, icon: CreditCard, desc: "Stripe / Razorpay, coupons, GST invoicing, and EMI options." },
  { name: "Notifications", phase: 12, icon: Bell, desc: "Email, SMS, WhatsApp and push notifications with templates." },
  { name: "White Label LMS", phase: 13, icon: Globe, desc: "Custom domain, branding, and certificate templates per tenant." },
  { name: "Mobile App APIs", phase: 14, icon: Smartphone, desc: "Android / iOS app APIs, deep linking and offline sync." },
  { name: "Security & Deployment", phase: 15, icon: ShieldCheck, desc: "Hardening, backups, load testing, and production release." },
];

export default function AdminFutureModulesPage() {
  return (
    <DashboardLayout title="Future modules" breadcrumbs={["Platform", "Roadmap"]}>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid={ADMIN.futureRoot}>
        {MODULES.map((m) => {
          const Icon = m.icon;
          return (
            <div key={m.name} className="rounded-2xl border border-slate-200 bg-white p-6 transition hover:-translate-y-0.5 hover:border-[#101876]/40 hover:shadow-lg">
              <div className="flex items-center justify-between">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#101876]/5 text-[#101876]">
                  <Icon className="h-5 w-5" />
                </div>
                <span className="rounded-full bg-[#329112]/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-[#329112]">
                  Phase {m.phase}
                </span>
              </div>
              <h3 className="mt-4 text-base font-bold text-slate-900">{m.name}</h3>
              <p className="mt-1 text-sm leading-relaxed text-slate-600">{m.desc}</p>
              <div className="mt-4 text-[10px] font-bold uppercase tracking-widest text-slate-500">Status: Not started</div>
            </div>
          );
        })}
      </div>
    </DashboardLayout>
  );
}
